import { showToastMessageProps } from "../../hooks/useToast"
import { checkIfPermissionUpdate, isAllowedNow } from "../../util"

const getUpdatedPermissionInfo = (
  newPermissions: number,
  oldPermissions: number
) => {
  const { canUseMic, canUseCam, canUseScreenshare } =
    window.MeetOnline.UserPermission
  if (newPermissions === oldPermissions) return undefined

  return {
    micPermissionUpdate: checkIfPermissionUpdate(
      newPermissions,
      oldPermissions,
      canUseMic
    ),
    micAllowed: isAllowedNow(newPermissions, canUseMic),
    camPermissionUpdate: checkIfPermissionUpdate(
      newPermissions,
      oldPermissions,
      canUseCam
    ),
    camAllowed: isAllowedNow(newPermissions, canUseCam),
    screenSharePermissionUpdate: checkIfPermissionUpdate(
      newPermissions,
      oldPermissions,
      canUseScreenshare
    ),
    screenShareAllowed: isAllowedNow(newPermissions, canUseScreenshare)
  }
}

const notifyUserIfPermissionChanged = (
  newPermissions: number,
  oldPermissions: number,
  showToastMessage: showToastMessageProps,
  isMobile = false
) => {
  if (oldPermissions) {
    const r = getUpdatedPermissionInfo(newPermissions, oldPermissions)
    if (r === undefined) return

    // Notify if All presenters have left or Joined
    if (
      r.micPermissionUpdate &&
      r.camPermissionUpdate &&
      r.screenSharePermissionUpdate
    ) {
      if (r.micAllowed && r.camAllowed && r.screenShareAllowed) {
        showToastMessage(
          "A presenter has joined",
          "You can now turn on your cam and mic if you wish"
        )
      } else {
        showToastMessage(
          "All presenters have left",
          "Interactivity has been disabled"
        )
      }
      return
    }

    // Notify mic permission changed
    if (r.micPermissionUpdate) {
      if (r.micAllowed) {
        showToastMessage("You can now turn your microphone on")
      } else {
        showToastMessage("Microphone access has been disabled")
      }
    }

    // Notify cam permission changed
    if (r.camPermissionUpdate) {
      if (r.camAllowed) {
        showToastMessage("You can now turn your webcam on")
      } else {
        showToastMessage("Camera access has been disabled")
      }
    }

    // Notify screen-share permission changed
    if (r.screenSharePermissionUpdate && !isMobile) {
      if (r.screenShareAllowed) {
        showToastMessage("You can now share your screen")
      } else {
        showToastMessage("Screen sharing has been disabled")
      }
    }
  }
}

export default notifyUserIfPermissionChanged
